// Moves each "Menu photo panel" (sections/sivana-header-extras.liquid) into its desktop dropdown.
// The panel sits next to the links, so the Horizon menu files stay untouched.
// Horizon redraws the header menu after load, so the panel is put back whenever it goes missing.
(() => {
  const place = () => {
    document.querySelectorAll('template.sivana-mega-feature-template').forEach((template) => {
      const title = template.dataset.menuTitle.trim();
      const item = [...document.querySelectorAll('header-menu .menu-list__list-item')].find(
        (li) => li.querySelector('.menu-list__link-title')?.textContent.trim() === title
      );
      const inner = item?.querySelector('.menu-list__submenu-inner');
      if (!inner || inner.querySelector('.sivana-mega-feature')) return;
      inner.append(template.content.cloneNode(true));
      item.classList.add('sivana-has-feature');
      if (template.dataset.hideTiles === 'true') item.classList.add('sivana-hide-tiles');
    });
  };
  const start = () => {
    place();
    const root = document.querySelector('header-menu')?.closest('.shopify-section') || document.body;
    new MutationObserver(place).observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
